import type { AuraBaseDesignTokens } from '@openng/optimus-ui-themes/aura/base';

import { components } from './tokens/components';
import { css } from './tokens/groups';
import { extend } from './tokens/groups/extend';
import { primitive } from './tokens/primitive';
import { semantic } from './tokens/semantic';

const base = { primitive, semantic } satisfies AuraBaseDesignTokens;

export const Tokens = {
	...base,
	components,
	extend,
	css,
};
